export function getVal(title,d,parent_code,qty){
    return {
        title,
        id:d['id'],
        name:d['name'],
        price:d['price'],
        extra_sku: d['extra_sku'] || d['code'],
        attribute:d['attribute'],
		parent_code,
        qty:qty??1
    }
}